import axios from "axios";
import { setAlert } from "./alert";
import customConfig from "../config";
import env from "../env";

export const changePassword = (newPassword) => async (dispatch) => {
  const umURL = env.GET_USERMANAGEMENT_API_URL();
  const validateUrl = `${umURL}/simplifi/v2/userManagement/changePassword`;
  const configVal = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = {
    newPassword: newPassword
  };

  try {
    const res = await axios.post(
      validateUrl,
      body,
      configVal
    );

    if(res.status === 200) {
      dispatch(setAlert(customConfig.passwordChangeSuccessful, "success"))
      setTimeout(() => {
            window.location.reload();
      }, 3000);
    }
    
  } catch (err) {
    if (!err.response) {
      dispatch(setAlert(customConfig.serverDownMsg, "danger"));
    } else if (err.response.status === 500) {
      dispatch(setAlert(err?.response?.data?.message || customConfig.passwordChangeError, "danger"));
    } else {
      dispatch(setAlert(customConfig.passwordChangeError, "danger"));
    }
  }  
}

export const forgotPasswordSendOtp = (email) => async (dispatch) => {
  const iamURL = env.GET_IAM_API_URL();
  const clientId = env.GET_CLIENT_ID();
  const validateUrl = `${iamURL}/api/identity/v1/auth/generateOtp`;
  const configVal = {
    headers: {
      "Content-Type": "application/json",
      "Tenantid": "panasonic"
    },
  };
  const body = {
    email: email,
    transactionType: "ResetPassword",
    clientId: clientId
  };
  try {
    const res = await axios.post(
      validateUrl,
      body,
      configVal
    );

    return res;
    
  } catch (err) {
    throw err;
  }  
}

export const forgotPasswordValidateOtp = (email, Otp) => async (dispatch) => {
  const iamURL = env.GET_IAM_API_URL();
  const validateUrl = `${iamURL}/api/identity/v1/auth/validateOtp`;
  const configVal = {
    headers: {
      "Content-Type": "application/json",
      "Tenantid": "panasonic"
    },
  };
  const body = {
    email: email,
    otp: Otp,
    transactionType: "ResetPassword"
  };
  try {
    const res = await axios.post(
      validateUrl,
      body,
      configVal
    );

    return res;
    
  } catch (err) {
    throw err;
  }  
}

export const forgotPassword = (email, newPassword, token) => async (dispatch) => {
  const iamURL = env.GET_IAM_API_URL();
  const validateUrl = `${iamURL}/api/identity/v1/auth/resetPassword`;
  const configVal = {
    headers: {
      "Content-Type": "application/json",
      "Tenantid": "panasonic"
    },
  };
  const body = {
    password: newPassword,
    token: token,
  };
  try {
    const res = await axios.post(
      validateUrl,
      body,
      configVal
    );

    return res;
    
  } catch (err) {
    throw err;
  }
}

const TRANSACTION_UPDATE_PROFILE = "UpdateProfile";

/**
 * Update profile — send OTP (mobile or email). Same pattern as forgotPasswordSendOtp.
 * POST /api/identity/v1/user/generateOtp
 */
export const generateUpdateProfileOtp = ({ mobile, email } = {}) => async (dispatch) => {
  const iamURL = env.GET_IAM_API_URL();
  const validateUrl = `${iamURL}/api/identity/v1/user/generateOtp`;
  const configVal = {
    headers: {
      "Content-Type": "application/json",
      "Tenantid": "panasonic",
    },
  };
  const body = { transactionType: TRANSACTION_UPDATE_PROFILE };
  if (mobile != null && String(mobile).trim() !== "") {
    body.mobile = String(mobile).trim();
  } else if (email != null && String(email).trim() !== "") {
    body.email = String(email).trim();
  }
  try {
    const res = await axios.post(validateUrl, body, configVal);
    return res;
  } catch (err) {
    throw err;
  }
};

/**
 * Update profile — validate OTP. Same pattern as forgotPasswordValidateOtp.
 * POST /api/identity/v1/user/validateOtp
 */
export const validateUpdateProfileOtp = ({ mobile, email, otp } = {}) => async (dispatch) => {
  const iamURL = env.GET_IAM_API_URL();
  const validateUrl = `${iamURL}/api/identity/v1/user/validateOtp`;
  const configVal = {
    headers: {
      "Content-Type": "application/json",
      "Tenantid": "panasonic",
    },
  };
  const body = { transactionType: TRANSACTION_UPDATE_PROFILE, otp };
  if (mobile != null && String(mobile).trim() !== "") {
    body.mobile = String(mobile).trim();
  } else if (email != null && String(email).trim() !== "") {
    body.email = String(email).trim();
  }
  try {
    const res = await axios.post(validateUrl, body, configVal);
    return res;
  } catch (err) {
    throw err;
  }
};